import AsyncStorage from '@react-native-async-storage/async-storage';

export enum LocalStorageType {
  accessToken = 'accessToken',
  refreshToken = 'refreshToken',
  navigationState = 'navigationState',
}

class LocalStorage {
  save = async (value: string, type: LocalStorageType) => {
    try {
      await AsyncStorage.setItem(type, value);
    } catch (e) {
      console.log('err', e);
    }
  };

  delete = async (type: LocalStorageType) => {
    try {
      await AsyncStorage.removeItem(type);
    } catch (e) {
      console.log('err', e);
    }
  };

  getValue = async (type: LocalStorageType) => {
    try {
      const value = await AsyncStorage.getItem(type);
      return value;
    } catch (e) {
      return undefined;
    }
  };
}

const localStorage = new LocalStorage();
export default localStorage;
